export default `---
slug: nepal
country: Nepal
countryCode: NPL
continent: Asia
year: 2023
title: "Nepal"
description: "The roof of the world — trekking, temples, and tea houses."
thumbnail: /images/travels/NPL/nepal_thumb.jpg
relatedLinks: []
---
![nepal](/images/travels/NPL/nepal_thumb.jpg)

*Story coming soon — stay tuned!*

I visited Nepal and it was an incredible experience. Full story and photos are being written up and will appear here soon.
`;
